import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import ReactTooltip from 'react-tooltip';

const DESCRIPTION_PREVIEW_LENGTH = 150;
const MODAL_CLASSNAMES = {
  modal: 'modal-max-width-65',
};

const buildDescriptionPreview = (description, previewLength = DESCRIPTION_PREVIEW_LENGTH) => {
  const trimmedDescription = description.trim();
  if (trimmedDescription.length <= previewLength) {
    return {
      preview: trimmedDescription,
      isTruncated: false,
    };
  }

  const breakIndex = trimmedDescription.lastIndexOf(' ', previewLength);
  const safeBreakIndex = breakIndex > 0 ? breakIndex : previewLength;

  return {
    preview: trimmedDescription.substring(0, safeBreakIndex).trimEnd(),
    isTruncated: true,
  };
};

export const BoxDescription = ({ id, description, children, enableInlineDescription }) => {
  const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);
  const trimmedDescription = description ? description.trim() : '';

  if (!trimmedDescription) {
    return children;
  }

  if (!enableInlineDescription) {
    const tooltipId = `box-desc-${id}`;
    return (
      <span data-test="box-description-trigger" data-tip={trimmedDescription} data-for={tooltipId}>
        {children}
        <ReactTooltip id={tooltipId} place="right" effect="solid" />
      </span>
    );
  }

  const { preview, isTruncated } = buildDescriptionPreview(trimmedDescription);
  const descriptionId = `box-desc-inline-${id}`;
  const currentDescriptionIds = children?.props?.['aria-describedby'] || '';
  const childDescriptionIds = currentDescriptionIds
    ? `${currentDescriptionIds} ${descriptionId}`
    : descriptionId;
  const childWithDescription = React.isValidElement(children)
    ? React.cloneElement(children, { 'aria-describedby': childDescriptionIds })
    : children;

  return (
    <div data-test="box-description-container" className="vat-box-description">
      <div className="vat-box-description__content">
        {childWithDescription}
        <span
          id={descriptionId}
          data-test="box-description-inline"
          className="vat-box-description__inline"
        >
          {preview}
          {isTruncated && (
            <button
              type="button"
              data-test="box-description-more"
              className="vat-box-description__more"
            onClick={() => setIsDescriptionModalOpen(true)}
          >
            ...
          </button>
          )}
        </span>
      </div>
      {isTruncated && (
        <Modal
          open={isDescriptionModalOpen}
          onClose={() => setIsDescriptionModalOpen(false)}
          classNames={MODAL_CLASSNAMES}
        >
          <h3>Box description</h3>
          <p data-test="box-description-full" className="vat-box-description-modal__text">
            {trimmedDescription}
          </p>
        </Modal>
      )}
    </div>
  );
};


BoxDescription.defaultProps = {
  description: null,
  enableInlineDescription: false,
};

export default BoxDescription;
